import { StringFilter } from "react3l-advanced-filters";
import { IdFilter } from "react3l-advanced-filters";
import { DateFilter } from "react3l-advanced-filters";
import { GuidFilter } from "react3l-advanced-filters";
import { ModelFilter } from "react3l-common";

export class JobTitleFilter extends ModelFilter {
  public id?: IdFilter = new IdFilter();
  public code?: StringFilter = new StringFilter();
  public name?: StringFilter = new StringFilter();
  public statusId?: IdFilter = new IdFilter();
  public rowId?: GuidFilter = new GuidFilter();
  public createdAt?: DateFilter = new DateFilter();
  public updatedAt?: DateFilter = new DateFilter();
  public search?: string = null;
}
